import { render, staticRenderFns } from "./CMAddContact.vue?vue&type=template&id=0d876a31&"
import script from "./CMAddContact.vue?vue&type=script&lang=js&"
export * from "./CMAddContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d876a31')) {
      api.createRecord('0d876a31', component.options)
    } else {
      api.reload('0d876a31', component.options)
    }
    module.hot.accept("./CMAddContact.vue?vue&type=template&id=0d876a31&", function () {
      api.rerender('0d876a31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/CMAddContact.vue"
export default component.exports